import { DASHBOARD_PAGE_ROUTE_PAIRS, PAGE_KEYS } from 'src/constants/access';

const normalizeList = (items) => (Array.isArray(items) ? items.filter(Boolean) : []);

export const isSuperAdmin = (access) => Boolean(access?.isOwner);

export const hasPageAccess = (access, page) => {
  if (!page) return false;
  if (page === PAGE_KEYS.USERS) return isSuperAdmin(access);
  if (isSuperAdmin(access)) return true;
  const pages = normalizeList(access?.pages);
  return pages.includes(page);
};

export const filterMenuItemsByAccess = (items, access, routeToPageMap) =>
  items.filter((item) => {
    const requiredPage = routeToPageMap[item.key];

    if (!requiredPage) {
      return true;
    }

    return hasPageAccess(access, requiredPage);
  });

export const getFirstAllowedDashboardRoute = (access) => {
  const found = DASHBOARD_PAGE_ROUTE_PAIRS.find((pair) => hasPageAccess(access, pair.page));
  return found?.route || null;
};
